module.exports = __webpack_public_path__ + "img/caja-tacna.f451b699.svg";